module.exports = "<div class=team-agent-photo> <img itemprop=image src=\"<%- resize(profile, 'profile_photo', 260) %>\" alt=\"A photo of <%- profile.first_name %> <%- profile.last_name %>\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./templates/team-photo.html
// module id = 177
// module chunks = 0